import { useEffect, useState } from "react";
import { AnimatePresence, motion } from "framer-motion";
import Crest from "@/components/Crest";
import { EASE } from "@/lib/motion";

export default function Curtain() {
  const [gone, setGone] = useState(false);

  useEffect(() => {
    if (window.matchMedia("(prefers-reduced-motion: reduce)").matches) {
      setGone(true);
      return undefined;
    }
    const t = setTimeout(() => setGone(true), 1150);
    return () => clearTimeout(t);
  }, []);

  return (
    <AnimatePresence>
      {!gone && (
        <>
          <motion.div
            key="curtain-gold"
            initial={{ y: 0 }}
            exit={{ y: "-100%" }}
            transition={{ duration: 1, ease: EASE, delay: 0.07 }}
            onClick={() => setGone(true)}
            className="fixed inset-0 z-[199] bg-gold"
            data-testid="load-curtain-gold"
          />
          <motion.div
            key="curtain"
            initial={{ y: 0 }}
            exit={{ y: "-100%" }}
            transition={{ duration: 1, ease: EASE }}
            onClick={() => setGone(true)}
            className="fixed inset-0 z-[200] flex cursor-pointer flex-col items-center justify-center bg-ink"
            data-testid="load-curtain"
          >
            <motion.div initial={{ opacity: 0, scale: 0.8 }} animate={{ opacity: 1, scale: 1 }} transition={{ duration: 0.6, ease: EASE }}>
              <Crest className="h-16 w-16" />
            </motion.div>
            <motion.p
              initial={{ opacity: 0, y: 12 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ delay: 0.2, duration: 0.55, ease: EASE }}
              className="mt-5 font-mono text-[10px] uppercase tracking-[0.5em] text-gold"
            >
              Chandbagh • 1935 — 2026
            </motion.p>
            <motion.div
              initial={{ scaleX: 0 }}
              animate={{ scaleX: 1 }}
              transition={{ delay: 0.25, duration: 0.8, ease: EASE }}
              className="mt-6 h-px w-40 origin-center bg-gradient-to-r from-transparent via-gold to-transparent"
            />
          </motion.div>
        </>
      )}
    </AnimatePresence>
  );
}
